import usePrintMode from '@/composables/export/print-mode';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { viewType } from 'shared/constants.json';

export default function useLoadLimit(savedView) {
  const { t } = useI18n();
  const { isPrint } = usePrintMode();

  const loadLimitOptions = [
    { text: '10', value: 10 },
    { text: '25', value: 25 },
    { text: '50', value: 50 },
    { text: '100', value: 100 },
  ];

  const defaultLoadLimit = (type) => {
    if ([viewType.cascade, viewType.tree, viewType.atlas].includes(type)) {
      return 10;
    }
    return 25;
  };

  const loadLimitLabel = computed(() => {
    if ([viewType.cascade, viewType.tree, viewType.atlas].includes(savedView.value.viewType)) {
      return t('documentListHeader.loadLimitRoot');
    }
    return t('documentListHeader.loadLimit');
  });

  const loadLimit = computed(() => {
    if (isPrint.value) {
      return 500;
    }

    if (savedView.value.params?.loadLimit !== undefined) {
      return savedView.value.params.loadLimit;
    }
    return defaultLoadLimit(savedView.value.viewType);
  });

  const renderedItemsLimit = computed(() => {
    if (isPrint.value) {
      // Assuming that goals have an average of 3 children.
      return loadLimit.value * 3;
    }

    if ([viewType.cascade, viewType.tree, viewType.atlas].includes(savedView.value.viewType)) {
      return 25;
    }
    return loadLimit.value;
  });

  return { loadLimitOptions, defaultLoadLimit, loadLimit, loadLimitLabel, renderedItemsLimit };
}
